import { render, staticRenderFns } from "./BillableMethodAdd.vue?vue&type=template&id=bcc00b02"
import script from "./BillableMethodAdd.vue?vue&type=script&lang=js"
export * from "./BillableMethodAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports